var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"van-fade","mode":"out-in"}},[(_vm.curActive === 'LoginMobile')?_c('LoginMobile',{on:{"sendSmsCode":_vm.sendSmsCode}}):_vm._e(),(_vm.curActive === 'LoginCode')?_c('LoginCode',{attrs:{"mobile":_vm.mobile}}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }